import { apiSlice } from './apiSlice';
import {
  NotificationsResponse,
  UnreadNotificationsResponse,
  ReadAllResponse,
} from '@/types/notification';

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationsResponse, void>({
      query: () => ({
        url: '/push-notification',
        method: 'GET',
        params: { page: 1, limit: 20, ts: Date.now() },
      }),
      providesTags: ['AdminNotification'],
    }),
    getUnreadNotifications: builder.query<UnreadNotificationsResponse, void>({
      query: () => ({
        url: '/push-notification/unread',
        method: 'GET',
        params: { ts: Date.now() },
      }),
      providesTags: ['AdminNotification'],
    }),
    markAllRead: builder.mutation<ReadAllResponse, void>({
      query: () => ({
        url: '/push-notification/read',
        method: 'POST',
      }),
      invalidatesTags: ['AdminNotification'],
    }),
  }),
});

export const { useGetNotificationsQuery, useGetUnreadNotificationsQuery, useMarkAllReadMutation } =
  notificationApi;
